import React, { useCallback, useMemo, useState, Fragment, memo } from 'react'
import PropTypes from 'prop-types'
import { Box } from '@material-ui/core'

import Form from 'Components/Form'
import { Input } from 'Components/Form/Input'
import { SectionTitle } from 'Components/Section/SectionTitle'
import { SectionWrapper } from 'Components/Section/SectionWrapper'
import { SelectDashboard } from 'Components/Form/SelectDashboard'
import SubmitButton from 'Components/Form/SubmitButton'

import { number, required } from 'Utils/Validators/formValidation'
import { globalSort } from '../../../../shared/libraries/sort'
import {
  AMBASSADOR_PER_MISSION,
  HOURS_PER_MISSION,
  CAMPAIGN_ENUM_TYPES,
} from '../../../../shared/constants'

function CreateCityPlanFormUnstyled(props) {
  const { className, onSubmit, cities, campaign } = props
  const [missionType, setMissionType] = useState(AMBASSADOR_PER_MISSION)

  const handleFormUpdate = useCallback(
    (item, form) => {
      const { missionType } = form
      if (missionType && missionType.value) {
        setMissionType(missionType.value)
      }
    },
    [missionType],
  )

  const handleFormSubmit = useCallback((form, isValid) => {
    if (isValid) {
      const prettyFormData = {}
      for (const [key, value] of Object.entries(form)) {
        const valueNumber = Number(value.value)
        prettyFormData[key] = valueNumber ? valueNumber : value.value
      }
      onSubmit(prettyFormData)
    }
  }, [])

  return (
    <Form onUpdate={handleFormUpdate} onSubmit={handleFormSubmit}>
      <form className={className}>
        <SectionWrapper className="section-wrapper">
          <SectionTitle className="section-title">City Details</SectionTitle>
          <Box display="flex" mt={3}>
            <Box width={300} mr={5}>
              <CitySelect cities={cities} campaign={campaign} />
            </Box>
            <Box display="flex">
              {CAMPAIGN_ENUM_TYPES[campaign.type] === 'LETTERBOX' && (
                <Box width={150} mr={5}>
                  <MissionTypeSelect />
                </Box>
              )}
              {missionType === AMBASSADOR_PER_MISSION && (
                <Fragment>
                  <Box mr={5}>
                    <PayoutInput />
                  </Box>
                  <Box>
                    <DistributionCostInput />
                  </Box>
                </Fragment>
              )}
              {missionType === HOURS_PER_MISSION &&
                CAMPAIGN_ENUM_TYPES[campaign.type] === 'LETTERBOX' && (
                  <Fragment>
                    <Box mr={5}>
                      <HourlyPayoutInput />
                    </Box>
                    <Box>
                      <ClientMarginPercentInput />
                    </Box>
                  </Fragment>
                )}
            </Box>
          </Box>
        </SectionWrapper>
        <SubmitButton className="submit-button" value="Save" />
      </form>
    </Form>
  )
}

CreateCityPlanFormUnstyled.propTypes = {
  change: PropTypes.func.isRequired,
  cities: PropTypes.array.isRequired,
}

const CitySelect = memo(prop => {
  const { cities, campaign } = prop

  const options = useMemo(() => {
    if (!campaign) {
      return null
    }

    return globalSort({
      data: cities.map(city => ({
        label: city.name,
        value: city.id,
      })),
      sortingKey: 'label',
      ASC: true,
    })
  }, [cities, campaign])

  return (
    <SelectDashboard
      label="City"
      options={options}
      validator={[required, number]}
      name="citySelect"
    />
  )
})

const MissionTypeSelect = memo(() => (
  <SelectDashboard
    label="Mission Type"
    name="missionType"
    initValue={AMBASSADOR_PER_MISSION}
    options={[
      {
        label: 'Per Mission',
        value: AMBASSADOR_PER_MISSION,
      },
      {
        label: 'Per Hour',
        value: HOURS_PER_MISSION,
      },
    ]}
  />
))

const PayoutInput = memo(() => (
  <Input
    name="payout"
    label="BA Surge Or Letterbox Payout (Per Mission)"
    placeholder="52"
    validator={[required, number]}
  />
))

const DistributionCostInput = memo(() => (
  <Input
    name="distributionCost"
    label="Distribution Cost For Customer (Per Mission)"
    placeholder="105"
    validator={[required, number]}
  />
))

const HourlyPayoutInput = memo(() => (
  <Input
    name="hourlyPayout"
    label="BA hourly pay"
    placeholder="10"
    validator={[required, number]}
  />
))

const ClientMarginPercentInput = memo(() => (
  <Input
    name="clientMarginPercent"
    label="Client Margin (%)"
    placeholder="5"
    validator={[required, number]}
  />
))

export default CreateCityPlanFormUnstyled



// WEBPACK FOOTER //
// ./src/Containers/Form/Campaigns/CreateCityPlan/unstyled.js